@if (isInternal()) {
    <a [routerLink]="link()" [target]="target()" class="no-underline hover:no-underline">
        <sh-button
            [icon]="icon()"
            iconPosition="left"
            size="max-content"
            [color]="color()"
            [label]="label()!"
            [ariaLabel]="ariaLabel()!"
            tabindex="-1"
        />
    </a>
} @else {
    <a [href]="link()" [target]="target()" [rel]="rel()" class="no-underline hover:no-underline">
        <sh-button
            [icon]="icon()"
            iconPosition="left"
            size="max-content"
            [color]="color()"
            [label]="label()!"
            [ariaLabel]="ariaLabel()!"
            tabindex="-1"
        />
    </a>
}
